import { isMobile } from 'react-device-detect';
import constants from '../constants';
import DateHelpers from './DateHelper';
import TextHelper from './TextHelper';

export default class CardHelpers {
  public static readonly getDivisor = (
    oe: any,
    os: any,
    ae: any,
    ev: any,
    gm: any
  ) => {
    const limitWidthMax = 3;
    const limitWidthMin = 2;
    const overlapingFromCurrentEvent = oe.length;
    let divisor = 1;
    let max = 0;
    const m = os.map((e: any) => {
      if (e?.eventCrossAtTime?.length > max) {
        max = e.eventCrossAtTime.length;
      }
      return max;
    });

    let maxOverlapingFromOthersEvents = m && m.length ? m.length : oe.length;

    if (maxOverlapingFromOthersEvents > limitWidthMax) {
      maxOverlapingFromOthersEvents = limitWidthMax;
    }

    if (maxOverlapingFromOthersEvents > overlapingFromCurrentEvent) {
      divisor = maxOverlapingFromOthersEvents;
    } else {
      divisor = overlapingFromCurrentEvent;
    }
    if (gm && gm.length && gm > oe) {
      divisor = gm.length;
    }

    if (divisor > limitWidthMax) {
      divisor = limitWidthMax;
    }

    if (divisor < limitWidthMin) {
      divisor = limitWidthMin;
    }

    return divisor;
  };

  public static readonly getWidthBkp = (
    oe: any,
    os: any,
    ae: any,
    ev: any,
    gm: any
  ) => {
    let w = 100;
    if (oe.length > 0) {
      w = Math.trunc(w / CardHelpers.getDivisor(oe, os, ae, ev, gm));
    }
    return w;
  };

  public static readonly getHeight = (ev: any) => {
    const pixelPerMinute = constants.PIXELS_PER_MIN; // 1.6666; // 0.6666;
    return Math.round(((ev.end - ev.start) / (1000 * 60)) * pixelPerMinute);
  };

  public static readonly getTop = (ev: any) => {
    const pixelPerMinute = constants.PIXELS_PER_MIN; // 1.6666; // 0.6666;
    const startDate = new Date(ev.start);
    const startOfDay = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      7
    );

    return Math.round(
      ((ev.start - startOfDay.getTime()) / (1000 * 60)) * pixelPerMinute
    );
  };

  public static readonly getSpaceY = (ev: any) => {
    const s = CardHelpers.getTop(ev);
    const e = s + CardHelpers.getHeight(ev);
    return {
      start: s,
      end: e
    };
  };

  public static readonly getLeft = (event: any, events: any, width: any) => {
    const limitMin = 0;
    let pos = limitMin;

    if (event.order === 0) {
      // pos = 0;
    } else {
      // 1. escalonamiento
      // verificar si el elemento previo esta en la misma linea de cruce
      const lineCross = DateHelpers.dateRangeOverlaping(
        event.start,
        event.end,
        events[event.order - 1].start,
        events[event.order - 1].end
      );
      const sd = new Date(event.start);
      // avanzar dependiendo de la posicion previa de forma escalonada.
      // a) obtener position de element previo
      if (lineCross) {
        const widthPrev = CardHelpers.getWidth(events[event.order - 1], events);
        const posLeftPrev = CardHelpers.getLeft(
          events[event.order - 1],
          events,
          widthPrev
        );
        switch (width) {
          case 50:
            switch (posLeftPrev) {
              case 0:
                pos = 50;
                break;
              case 50:
                pos = 0;
                break;
              default:
                break;
            }
            break;
          case 33:
            switch (posLeftPrev) {
              case 0:
                pos = 33;
                break;
              case 33:
                pos = 66;
                break;
              case 66:
                pos = 0;
                break;
              default:
                break;
            }
            break;
          case 100:
            break;
          default:
            break;
        }
      }

      // 2. altura (excepcion)

      // si un elemento alto se cruza (pertenece a mas de una linea de cruce) rompe estructura escalonada : corregir basado en la altura maxima

      // verificar si el elemento mas alto de los que se cruzan conmigo esta en mi misma posicion

      const ol = DateHelpers.OverlapingList(event, events);
      const os = ol.length > 0 ? DateHelpers.OverlapingSelf(ol, events) : [];

      const gm = DateHelpers.getGroupOfMax(os) ?? [];

      if (ol.length && gm.length) {
        const highestThanMeAndCross: any = [];
        gm.forEach((e: any) => {
          // podrias haber mas de un elemento super alto en un ancho de 4 en uno de 3 no aplica
          // si son mas altos que este elemento y se cruzan con este elemento
          if (
            CardHelpers.getHeight(e) > CardHelpers.getHeight(event) &&
            DateHelpers.dateRangeOverlaping(
              event.start,
              event.end,
              e.start,
              e.end
            )
          ) {
            highestThanMeAndCross.push(e);
          }
        });

        if (sd.getDay() === 4) {
          // vacío
        }
        // si y solo si no soy el mas alto : los altos no se acomodan, en cambio los bajos se acomodan a los altos
        if (
          highestThanMeAndCross.length &&
          highestThanMeAndCross[0].order < event.order &&
          event.order - 1 !== highestThanMeAndCross[0].order
        ) {
          // console.log('enter here');
          // obtener ancho  y posicion left del mas alto.
          const wHighestEl = CardHelpers.getWidth(
            highestThanMeAndCross[0],
            events
          );
          let lHightestEl = 0;
          if (highestThanMeAndCross[0].order !== 0) {
            lHightestEl = CardHelpers.getLeft(
              highestThanMeAndCross[0],
              events,
              wHighestEl
            );
          }
          // console.log('left pos del mas alto', lHightestEl);
          // verificar que no sea el mismo ancho.
          if (pos === lHightestEl) {
            // si se da se estan superponiendo corregir
            switch (width) {
              case 50:
                switch (lHightestEl) {
                  case 0:
                    pos = 50;
                    break;
                  case 50:
                    pos = 0;
                    break;
                  default:
                    break;
                }
                break;
              case 33:
                switch (lHightestEl) {
                  case 0:
                    pos = 33;
                    break;
                  case 33:
                    pos = 66;
                    break;
                  case 66:
                    pos = 0;
                    break;
                  default:
                    break;
                }
                break;
              default:
                break;
            }
          }
        }

        // caso elemento cruza con todos : si el gm del elemento actual === ol de cualquiera de los elementos con lo que se cruza
        // entonces ese elementos es el mas alto que cruza con todos.
        // es entorno de 3 solo se puede dar 1 megaelemento en entorno de 4 podrian ser mas
        const megaElements: any = [];

        // condicion : yo debo ser el ultimo :  mi indice debe ser mayor a los indices que los que se cruzan conmigo

        if (gm.length > ol.length) {
          const indsOL: any = [];
          ol.forEach((ie: any) => {
            indsOL.push(ie.order);
          });

          const indMax = Math.max(...indsOL);
          if (indMax < event.order) {
            ol.forEach((te: any) => {
              const olte = DateHelpers.OverlapingList(te, events);
              if (olte.length === gm.length) {
                megaElements.push(te);
              }
              indsOL.push(te.order);
            });
            if (megaElements.length) {
              // obtener ancho  y posicion left del mas alto.
              const wHighestElMega = CardHelpers.getWidth(
                megaElements[0],
                events
              );
              let lHightestElMega = 0;
              if (megaElements[0].order !== 0) {
                lHightestElMega = CardHelpers.getLeft(
                  megaElements[0],
                  events,
                  wHighestElMega
                );
              }
              // verificar que no sea el mismo ancho.
              if (pos === lHightestElMega) {
                // si se da se estan superponiendo corregir
                switch (width) {
                  case 50:
                    switch (lHightestElMega) {
                      case 0:
                        pos = 50;
                        break;
                      case 50:
                        pos = 0;
                        break;
                      default:
                        break;
                    }
                    break;
                  case 33:
                    switch (lHightestElMega) {
                      case 0:
                        pos = 33;
                        break;
                      case 33:
                        pos = 66;
                        break;
                      case 66:
                        pos = 0;
                        break;
                      default:
                        break;
                    }
                    break;
                  default:
                    break;
                }
              }
            }
          }
        }
      }
    }

    return pos;
  };

  public static readonly fixWidth = (event: any, events: any, width: any) => {
    // de los elementos con los que me cruzo tenemos tenemos todos el mismo ancho?
    let w = width;

    const overlapingEvents =
      events.length > 0 ? DateHelpers.OverlapingList(event, events) : [];

    const overlapingSelf =
      overlapingEvents.length > 0
        ? DateHelpers.OverlapingSelf(overlapingEvents, events)
        : [];

    const GroupMax = DateHelpers.getGroupOfMax(overlapingSelf) ?? [];

    const indP = event.order - 1;
    if (indP >= 0) {
      if (
        DateHelpers.dateRangeOverlaping(
          event.start,
          event.end,
          events[indP].start,
          events[indP].end
        )
      ) {
        const prevW = CardHelpers.getWidth(events[indP], events);
        if (w !== prevW) {
          w = prevW;
        }
      }
    }

    if (GroupMax.length >= overlapingEvents.length) {
      if (GroupMax.length === 2) {
        w = 50;
      } else if (GroupMax.length === 3) {
        w = 33;
      } else if (GroupMax.length > 3) {
        w = 33;
      }
    }
    // lineas de cruces para los elementos que se cruzan conmigo.
    let countLines = 0;
    if (overlapingEvents.length > 0) {
      countLines = 1;
    }
    // si el numero de lineas es mayor al divisor
    // obtener cada elemento que cruza conmigo
    overlapingEvents.forEach((e: any) => {
      // determinar si ese elemento se cruza con otro que tambien se a su vez cruza conmigo (cruce de 3)
      const ote = DateHelpers.OverlapingList(e, events);

      // excluirme de entre los elementos con los que se cruza
      const nArrEls: any = [];
      ote.forEach((se: any) => {
        if (se.eventId !== event.eventId) {
          nArrEls.push(se);
        }
        return se;
      });
      nArrEls.forEach((ne: any) => {
        const crossLine = DateHelpers.dateRangeOverlaping(
          ne.start,
          ne.end,
          event.start,
          event.end
        );
        if (crossLine) {
          countLines += 1;
        }
        return ne;
      });
    });
    // como no tiene espacio suficiente se cambia el tamaño
    if (w !== 33 && countLines > 2) {
      w = 33;
    }

    return w;
  };

  public static readonly getWidth = (event: any, events: any) => {
    const ol = DateHelpers.OverlapingList(event, events);
    let w = 100;

    if (ol.length === 0) {
      w = 100;
    }
    if (ol.length === 1) {
      w = 50;
    }
    if (ol.length === 2) {
      const en1 = ol[0];
      const en2 = ol[1];
      if (
        DateHelpers.dateRangeOverlaping(en1.start, en1.end, en2.start, en2.end)
      ) {
        w = 33;
      } else {
        w = 50;
      }
    }

    if (ol.length) {
      const indsOL: any = [];
      ol.forEach((ie: any) => {
        indsOL.push(ie.order);
      });

      const indMin = Math.min(...indsOL);
      if (indMin > event.order) {
        // vacío
      }
    }

    if (ol.length > 2) {
      // vacío
    }
    // if MaxGroup tiene un ancho menor al mio entonces
    // yo debo tener el mismo ancho;

    w = CardHelpers.fixWidth(event, events, w);

    return w;
  };

  public static readonly getLeftBkp = (event: any, events: any, width: any) => {
    let limitMax = 100;
    let divisor = 1;
    if (width === 25) {
      divisor = 4;
      limitMax = 75;
    }
    if (width === 33) {
      divisor = 3;
      limitMax = 66;
    }
    if (width === 50) {
      divisor = 2;
      limitMax = 50;
    }

    let pos = limitMax;
    // let countA = 0;
    // let countB = 0;
    let stopBucleA = true;
    let stopBucleB = true;
    let indiceA = event.order;
    let indiceB = event.order;
    let firstIndice = event.order;
    const storeElements: any = [];
    if (width !== 100) {
      while (stopBucleA) {
        indiceA += 1;

        if (indiceA >= divisor) {
          stopBucleA = false;
        } else {
          const nextElement = events[indiceA];
          const nxoe = DateHelpers.OverlapingList(nextElement, events);
          const nxos = DateHelpers.OverlapingSelf(nxoe, events);
          const nxgm = DateHelpers.getGroupOfMax(nxos);
          const widthOfNextElement = CardHelpers.getWidthBkp(
            nxoe,
            nxos,
            events,
            nextElement,
            nxgm
          );
          if (width === widthOfNextElement) {
            storeElements.push(indiceA);
          } else {
            stopBucleA = false;
          }
        }
      }
      while (stopBucleB) {
        indiceB -= 1;
        if (indiceB <= 0) {
          stopBucleB = false;
        } else {
          const prevElement = events[indiceB];
          if (prevElement) {
            const pxoe = DateHelpers.OverlapingList(prevElement, events);
            const pxos = DateHelpers.OverlapingSelf(pxoe, events);
            const pxgm = DateHelpers.getGroupOfMax(pxos);
            const widthOfPrevElement = CardHelpers.getWidthBkp(
              pxoe,
              pxos,
              events,
              prevElement,
              pxgm
            );

            if (width === widthOfPrevElement) {
              storeElements.push(indiceB);
            } else {
              stopBucleB = false;
              firstIndice = indiceB;
            }
          }
        }
      }
    } else {
      pos = 0;
    }
    if (width !== 100) {
      let indprev = event.order - 1;
      const spaceJump = event.order - divisor + 1;
      let stopBucleC = true;
      const storeCross: any = [];
      if (firstIndice >= divisor) {
        while (stopBucleC) {
          if (indprev >= 0) {
            const previousElementJumper = events[indprev];
            const isCross = DateHelpers.dateRangeOverlaping(
              event.start,
              event.end,
              previousElementJumper.start,
              previousElementJumper.end
            );
            if (!isCross) {
              stopBucleC = false;
            }
            storeCross.push(isCross);
            indprev -= 1;
          } else {
            stopBucleC = false;
          }
        }

        pos -= width * (storeCross.filter(Boolean).length * spaceJump);
      }
    }

    return pos;
  };

  public static readonly getCardDetailPosition = (
    index: number,
    someType: any,
    passedDays?: number
  ) => {
    let pos = '';

    if (passedDays === 0 || passedDays === 6 || passedDays === 5) {
      pos = 'right';
    } else {
      pos = 'left';
    }

    if (someType === constants.CARD_TYPES.CURSO_VIRTUAL) {
      if (index <= 3) {
        pos += ' default top';
      } else {
        pos += ' right top';
      }
    }

    return pos;
  };

  public static readonly getCardSummaryBackgroundColor = (someType: any) => {
    switch (someType) {
      case constants.CARD_TYPES.CURSO_PRESENCIAL:
        return 'var(--decorative-decorative07)';
      case constants.CARD_TYPES.CURSO_REMOTO: // curso : remoto
        return 'var(--decorative-decorative03)';
      case constants.CARD_TYPES.ACTIVIDAD: // actividad
        return 'var(--decorative-decorative05)';
      case constants.CARD_TYPES.REFORZAMIENTO: // reforzamiento academico
        return 'var(--decorative-decorative06)';
      case constants.CARD_TYPES.EXAMEN: // examenes
        return 'var(--decorative-decorative04)';
      default:
        return 'var(--decorative-decorative03)';
    }
  };

  public static readonly getCardTagBackgroundColor = (someType: any) => {
    let color;
    switch (someType) {
      case constants.CARD_TYPES.CURSO_PRESENCIAL: // curso : presencial
        color = '#FFF8F7';
        break;
      case constants.CARD_TYPES.CURSO_VIRTUAL: // curso : virtual
        color = '#FCDAE2';
        break;
      case constants.CARD_TYPES.CURSO_REMOTO: // curso : remoto o presencial
        color = '#B3EBFE';
        break;
      case constants.CARD_TYPES.ACTIVIDAD: // actividad
        color = '#ecdef5';
        break;
      case constants.CARD_TYPES.REFORZAMIENTO: // reforzamiento academico
        color = '#e3fffe';
        break;
      case constants.CARD_TYPES.EXAMEN: // examenes
        color = '#ffdbd0';
        break;
      default:
        color = 'var(--decorative-decorative03)';
        break;
    }

    return color;
  };

  public static readonly getCardTagColor = (someType: any) => {
    let color;
    switch (someType) {
      case constants.CARD_TYPES.CURSO_REMOTO: // curso : remoto o presencial
        color = 'var(--decorative-decorative11)';
        break;
      case constants.CARD_TYPES.ACTIVIDAD: // actividad
        color = 'var(--decorative-decorative05)';
        break;
      case constants.CARD_TYPES.REFORZAMIENTO: // reforzamiento academico
        color = 'var(--decorative-decorative06)';
        break;
      case constants.CARD_TYPES.EXAMEN:
        color = 'var(--decorative-decorative04)';
        break;
      case constants.CARD_TYPES.CURSO_VIRTUAL: // curso : virtual
        color = 'var(--decorative-decorative10)';
        break;
      case constants.CARD_TYPES.CURSO_PRESENCIAL: // curso : presencial
        color = 'var(--decorative-decorative09)';
        break;
      default:
        color = '#2a3247';
        break;
    }

    return color;
  };

  public static readonly getCardTagLabel = (someType: any) => {
    let s = '';
    switch (someType) {
      case constants.CARD_TYPES.CURSO_REMOTO: // curso : remoto
        s = 'Virtual en vivo'; // se cambia Remoto por Virtual.
        break;
      case constants.CARD_TYPES.ACTIVIDAD: // actividad
        s = 'Eventos';
        break;
      case constants.CARD_TYPES.REFORZAMIENTO: // reforzamiento academico
        s = 'R. Académico';
        break;
      case constants.CARD_TYPES.CURSO_VIRTUAL: // virtual
        s = 'Virtual 24/7';
        break;
      case constants.CARD_TYPES.CURSO_PRESENCIAL: // curso : presencial
        s = 'Presencial';
        break;
      case constants.CARD_TYPES.EXAMEN: // examen
        s = 'Evaluación';
        break;
      default:
        s = 'Remoto';
        break;
    }
    return s;
  };

  public static readonly getCardSummaryInfo = (
    start: any,
    end: any,
    element: any,
    someType: string
  ) => {
    const pixelPerMinute = constants.PIXELS_PER_MIN; // 1.6666; // 0.6666;
    const startDate = new Date(start);
    const startOfDay = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      7
    );
    let l = 0;
    let w = 100;
    // let type = `card-${w}-w`;
    const h = Math.round(((end - start) / (1000 * 60)) * pixelPerMinute);

    const t = Math.round(
      ((start - startOfDay.getTime()) / (1000 * 60)) * pixelPerMinute
    );

    if (
      someType !== constants.CARD_TYPES.CURSO_VIRTUAL &&
      element?.meetings?.length
    ) {
      w = CardHelpers.getWidth(element, element.meetings);
      l = CardHelpers.getLeft(element, element.meetings, w);
      if (w !== 100) {
        if (startDate.getDay() === 4) {
          // vacío
        }
      }
    }

    return {
      height: h,
      left: l,
      top: t,
      width: w,
      zindex: 1,
      cssclass: `card-${w}-w`
    };
  };

  // public static getCardSummaryInfo2 = (
  //   start: any,
  //   end: any,
  //   element: any,
  //   someType: string
  // ) => {
  //   const pixelPerMinute = constants.PIXELS_PER_MIN; // 1.6666; // 0.6666;
  //   const startDate = new Date(start);
  //   const startOfDay = new Date(
  //     startDate.getFullYear(),
  //     startDate.getMonth(),
  //     startDate.getDate(),
  //     7
  //   );
  //   let l = 0;
  //   let w = 100;

  //   const h = Math.round(((end - start) / (1000 * 60)) * pixelPerMinute);

  //   const t = Math.round(
  //     ((start - startOfDay.getTime()) / (1000 * 60)) * pixelPerMinute
  //   );

  //   switch (someType) {
  //     case constants.CARD_TYPES.CURSO_REMOTO: // curso : remoto o presencial
  //       if (
  //         element.isOverlapingEvents.withActitities ||
  //         element.isOverlapingEvents.withReinforcement ||
  //         element.isOverlapingEvents.withExams
  //       ) {
  //         w = 50;
  //       }
  //       break;
  //     case constants.CARD_TYPES.ACTIVIDAD: // actividad
  //       if (
  //         element.isOverlapingEvents.withMeetings ||
  //         element.isOverlapingEvents.withReinforcement ||
  //         element.isOverlapingEvents.withExams
  //       ) {
  //         w = 50;
  //         l = 50;
  //       }
  //       break;
  //     case constants.CARD_TYPES.REFORZAMIENTO: // reforzamiento academico
  //       if (element.isOverlapingEvents.withMeetings) {
  //         w = 50;
  //         l = 50;
  //       } else if (element.isOverlapingEvents.withActitities) {
  //         w = 50;
  //       } else if (element.isOverlapingEvents.withExams) {
  //         w = 50;
  //       }
  //       break;
  //     case constants.CARD_TYPES.EXAMEN: // examen
  //       if (element.isOverlapingEvents.withActitities) {
  //         w = 50;
  //       } else if (
  //         element.isOverlapingEvents.withReinforcement ||
  //         element.isOverlapingEvents.withMeetings
  //       ) {
  //         w = 50;
  //         l = 50;
  //       }
  //       break;
  //     default:
  //       break;
  //   }

  //   return {
  //     height: h,
  //     left: l,
  //     top: t,
  //     width: w,
  //     zindex: 1
  //   };
  // };

  public static readonly getCardVirtualDetailPosition = (
    start: any,
    end: any,
    filter: number
  ) => {
    const pixelPerMinute = constants.PIXELS_PER_MIN; // 1.6666; // 0.6666;
    const startDate = new Date(start);
    const startOfDay = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      7
    );

    const height = Math.round(((end - start) / (1000 * 60)) * pixelPerMinute);

    const top = Math.round(
      ((start - startOfDay.getTime()) / (1000 * 60)) * pixelPerMinute
    );

    let value;
    if (filter) {
      value = height;
    } else {
      value = top;
    }

    return value;
  };

  public static readonly getTextprocessed = (
    info: any,
    content: string,
    type: string,
    someType: string
  ) => {
    let text = content;

    switch (type) {
      case 'title':
        if (info.height <= 80) {
          if (info.width <= 50) {
            text = TextHelper.elipsis(text, 8);
          }

          if (content.length > 25) {
            text = TextHelper.elipsis(text, 22);
          }
        }
        if (info.height <= 100) {
          text = TextHelper.elipsis(text, 33);
        }
        if (info.height <= 120) {
          text = TextHelper.elipsis(text, 41);
        }
        break;
      case 'tag':
        if (!isMobile) {
          if (info.width <= 33) {
            if (someType === constants.CARD_TYPES.REFORZAMIENTO) {
              text = text.replace('.', 'e');
            }
            text = `${text.substring(0, 2)}...`;
          }
          if (info.width <= 50) {
            text = TextHelper.elipsis(text, 7);
          }
        } else {
          if (
            someType === constants.CARD_TYPES.REFORZAMIENTO &&
            info.width === 33
          ) {
            text = `${text.substring(0, 7)}...`;
          }
          if (info.width === 25) {
            text = `${text.substring(0, 6)}...`;
          }
        }
        break;
      case 'hour':
        if (info.width <= 25) {
          text = text.substring(0, 5);
        }
        if (info.width <= 33) {
          text = text.substring(0, 6);
        }
        break;
      default:
        break;
    }

    return text;
  };

  static evalHeight(h: number) {
    let classElipsis = '';
    if (h === 60 || h < 60) {
      // 45 min.
      classElipsis = 'elipsis elipsis-1-lines';
    }
    if (h === 80 || (h < 80 && h > 60)) {
      // 1 hr
      classElipsis = 'elipsis elipsis-1-lines';
    }

    if (h === 100 || (h < 100 && h > 80)) {
      // 1 hr y 15
      classElipsis = 'elipsis elipsis-2-lines';
    }
    return classElipsis;
  }

  static evalHeight2(h: number) {
    let classElipsis = '';
    if (h === 120 || (h < 120 && h > 100)) {
      // 1 hr y 30
      classElipsis = 'elipsis elipsis-3-lines';
    }
    if (h === 140 || (h < 140 && h > 120)) {
      // 1 hr y 45
      classElipsis = 'elipsis elipsis-4-lines';
    }
    if (h === 160 || (h < 160 && h > 140)) {
      // 2 hrs
      classElipsis = 'elipsis elipsis-5-lines';
    }
    if (h === 180 || (h < 180 && h > 160)) {
      // 2 hrs y 15
      classElipsis = 'elipsis elipsis-6-lines';
    }
    if (h === 200 || (h < 200 && h > 180)) {
      // 2 hrs y 30
      classElipsis = 'elipsis elipsis-7-lines';
    }
    if (h === 220 || (h < 220 && h > 200)) {
      // 2 hrs y 45
      classElipsis = 'elipsis elipsis-8-lines';
    }
    if (h === 240 || (h < 240 && h > 220)) {
      // 3 hrs
      classElipsis = 'elipsis elipsis-9-lines';
    }
    return classElipsis;
  }

  static evalHeight3(h: number, w: number) {
    let classElipsis = '';
    if (w === 25 || w === 50 || w === 33) {
      classElipsis = this.evalHeight(h);
      classElipsis = this.evalHeight2(h);
    }
    return classElipsis;
  }

  public static readonly getTitleProcessed = (h: number, w: number) => {
    let classElipsis = 'no-elipsis';
    let minimal = 60; // 45min - desktop

    if (!isMobile) {
      if (w === 100) {
        classElipsis = this.evalHeight(h);
        if (h === 120 || (h < 120 && h > 100)) {
          // 1 hr y 30
          classElipsis = 'elipsis elipsis-2-lines';
        }
        if (h === 140 || (h < 140 && h > 120)) {
          // 1 hr y 45
          classElipsis = 'elipsis elipsis-4-lines';
        }
        if (h === 160 || (h < 160 && h > 140)) {
          // 2 hrs
          classElipsis = 'elipsis elipsis-5-lines';
        }
        if (h === 180 || (h < 180 && h > 160)) {
          // 2 hrs y 15
          classElipsis = 'elipsis elipsis-6-lines';
        }
        if (h === 200 || (h < 200 && h > 180)) {
          // 2 hrs y 30
          classElipsis = 'elipsis elipsis-7-lines';
        }
        if (h === 220 || (h < 220 && h > 200)) {
          // 2 hrs y 45
          classElipsis = 'elipsis elipsis-8-lines';
        }
        if (h === 240 || (h < 240 && h > 220)) {
          // 3 hrs
          classElipsis = 'elipsis elipsis-9-lines';
        }
      }
      classElipsis = this.evalHeight3(h, w);
    } else {
      minimal = 75; // 45min - mobile
      if (w === 100) {
        if (h <= minimal || h < 100) {
          // 1 hr
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h >= 100 && h < 125) {
          // 1 hr y 15
          classElipsis = 'elipsis elipsis-2-lines';
        }
      }
      if (w === 50) {
        if (h <= 150) {
          // 1 hr y 30
          classElipsis = 'elipsis elipsis-4-lines';
        }

        if (h <= 125) {
          // 1 hr y 15
          classElipsis = 'elipsis elipsis-3-lines';
        }

        if (h <= 100) {
          // 1 hr
          classElipsis = 'elipsis elipsis-1-lines';
        }
      }

      if (w === 33) {
        if (h === 85 || h < 85) {
          // 45min
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 100) {
          //  1 hora
          classElipsis = 'elipsis elipsis-2-lines';
        }

        if (h === 125) {
          //  1 hora y 15m
          classElipsis = 'elipsis elipsis-3-lines';
        }

        if (h === 150) {
          //  1 hora y 30m
          classElipsis = 'elipsis elipsis-4-lines';
        }

        if (h === 175) {
          //  1 hora y 45m
          classElipsis = 'elipsis elipsis-5-lines';
        }

        if (h === 200) {
          //  2 horas
          classElipsis = 'elipsis elipsis-5-lines';
        }

        if (h === 225) {
          //  2 horas y 15min
          classElipsis = 'elipsis elipsis-5-lines';
        }

        if (h === 200) {
          //  2 horas y 30min
          classElipsis = 'elipsis elipsis-5-lines';
        }

        if (h === 220) {
          //  2 horas y 45min
          classElipsis = 'elipsis elipsis-5-lines';
        }

        if (h >= 240) {
          //  3 horas
          classElipsis = 'elipsis elipsis-5-lines';
        }
      }

      if (w === 25) {
        if (h === 75) {
          // 45min
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 100) {
          //  1 hora
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 125) {
          //  1 hora y 15m
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 150) {
          //  1 hora y 30m
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 175) {
          //  1 hora y 45m
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 200) {
          //  2 horas
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 225) {
          //  2 horas y 15min
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 200) {
          //  2 horas y 30min
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 220) {
          //  2 horas y 45min
          classElipsis = 'elipsis elipsis-1-lines';
        }

        if (h === 240) {
          //  3 horas
          classElipsis = 'elipsis elipsis-1-lines';
        }
      }
    }

    return classElipsis;
  };

  static getObj(
    element: any,
    positionSummary: any,
    start: any,
    end: any,
    someType: any,
    courseName: any,
    dateFormated: any,
    professor: any
  ) {
    return {
      summary: {
        title: `Curso: ${TextHelper.capitalize(element.name)}`,
        styleClassTitle: CardHelpers.getTitleProcessed(
          positionSummary.height,
          positionSummary.width
        ),
        hour: CardHelpers.getTextprocessed(
          positionSummary,
          `${start} - ${end}`,
          'hour',
          someType
        ),
        position: positionSummary,
        background: CardHelpers.getCardSummaryBackgroundColor(someType)
      },
      detail: {
        title: courseName,
        date: dateFormated,
        hour: `${start} - ${end}`,
        teacher: professor,
        link: element.linkZoom,
        type: null,
        counter: null
      },
      tag: {
        label: CardHelpers.getTextprocessed(
          positionSummary,
          CardHelpers.getCardTagLabel(someType),
          'tag',
          someType
        ),
        label2: CardHelpers.getCardTagLabel(someType),
        color: CardHelpers.getCardTagColor(someType),
        background: CardHelpers.getCardTagBackgroundColor(someType)
      },
      classTypeText: ''
    };
  }

  public static readonly getIconprocessed = (info: any) => {
    let icon = true;
    if (info.width <= 47) {
      icon = false;
    }
    if (info.width <= 47 && isMobile) {
      icon = true;
    }
    return icon;
  };

  public static readonly getCardProcessed = (
    someType: any,
    element: any,
    dateEvent: any
  ) => {
    let objCard;
    let professor = '';

    if (typeof element.professor === 'string') {
      professor = element.professor;
    } else if (
      typeof element.professor === 'object' &&
      element.professor &&
      element.professor.length > 0
    ) {
      professor = `${element.professor[0].lastName}, ${element.professor[0].firstName}`;
    }

    const LowerName = element?.name?.toLowerCase();
    const courseName = LowerName?.charAt(0).toUpperCase() + LowerName?.slice(1);
    const start = DateHelpers.formatHour(element?.start);
    const end = DateHelpers.formatHour(element?.end);
    let entire;
    let dec;
    let hoursText;

    const dateFormated = TextHelper.capitalize(
      DateHelpers.formatFullDate(dateEvent?.date)
    );

    const positionSummary = CardHelpers.getCardSummaryInfo(
      element.start,
      element.end,
      element,
      someType
    );
    const objResume = this.getObj(
      element,
      positionSummary,
      start,
      end,
      someType,
      courseName,
      dateFormated,
      professor
    );

    switch (someType) {
      case constants.CARD_TYPES.CURSO_PRESENCIAL: // curso : presencial
        objCard = {
          ...objResume,
          textColor: '#fff',
          icon: CardHelpers.getIconprocessed(positionSummary),
          classTypeText: element.descAmb
            ? element.descAmb.charAt(0).toUpperCase() +
              element.descAmb.toLowerCase().slice(1)
            : ''
        };
        break;
      case constants.CARD_TYPES.CURSO_REMOTO: // curso : remoto
        objCard = {
          ...objResume,
          textColor: '#fff',
          icon: CardHelpers.getIconprocessed(positionSummary),
          classTypeText: ''
        };
        break;
      case constants.CARD_TYPES.ACTIVIDAD:
        objCard = {
          textColor: '#161D1F',
          summary: {
            title: `${element.name}`,
            styleClassTitle: CardHelpers.getTitleProcessed(
              positionSummary.height,
              positionSummary.width
            ),
            hour: CardHelpers.getTextprocessed(
              positionSummary,
              `${start} - ${end}`,
              'hour',
              someType
            ),
            position: positionSummary,
            background: CardHelpers.getCardSummaryBackgroundColor(someType)
          },
          detail: {
            title: element.name,
            date: dateFormated,
            hour: `${start} - ${end}`,
            teacher: professor,
            link: element.idZoom || '',
            type: null,
            counter: null
          },
          tag: {
            label: CardHelpers.getTextprocessed(
              positionSummary,
              CardHelpers.getCardTagLabel(someType),
              'tag',
              someType
            ),
            label2: CardHelpers.getCardTagLabel(someType),
            color: CardHelpers.getCardTagColor(someType),
            background: CardHelpers.getCardTagBackgroundColor(someType)
          },
          icon: CardHelpers.getIconprocessed(positionSummary),
          classTypeText: ''
        };
        break;
      case constants.CARD_TYPES.REFORZAMIENTO: // reforzamiento academico
        objCard = {
          textColor: '#161D1F',
          summary: {
            title: TextHelper.capitalize(
              element.name
                .replaceAll('Tutoría -', 'Tutoría:')
                .replaceAll('Taller -', 'Taller:')
            ),
            styleClassTitle: CardHelpers.getTitleProcessed(
              positionSummary.height,
              positionSummary.width
            ),
            hour: CardHelpers.getTextprocessed(
              positionSummary,
              `${start} - ${end}`,
              'hour',
              someType
            ),
            position: positionSummary,
            background: CardHelpers.getCardSummaryBackgroundColor(someType)
          },
          detail: {
            title: `Refuerzo Académico: ${courseName}`,
            date: dateFormated,
            hour: `${start} - ${end}`,
            teacher: professor,
            link: element.idZoom || '',
            counter: null
          },
          tag: {
            label: CardHelpers.getTextprocessed(
              positionSummary,
              CardHelpers.getCardTagLabel(someType),
              'tag',
              someType
            ),
            label2: CardHelpers.getCardTagLabel(someType),
            color: CardHelpers.getCardTagColor(someType),
            background: CardHelpers.getCardTagBackgroundColor(someType)
          },
          icon: CardHelpers.getIconprocessed(positionSummary)
        };
        break;
      case constants.CARD_TYPES.EXAMEN:
        objCard = {
          textColor: '#161D1F',
          summary: {
            title: `Evaluación: ${TextHelper.capitalize(element.name)}`,
            styleClassTitle: CardHelpers.getTitleProcessed(
              positionSummary.height,
              positionSummary.width
            ),
            hour: CardHelpers.getTextprocessed(
              positionSummary,
              `${start} - ${end}`,
              'hour',
              someType
            ),
            position: positionSummary,
            background: CardHelpers.getCardSummaryBackgroundColor(someType)
          },
          detail: {
            title: courseName,
            date: dateFormated,
            hour: `${start} - ${end}`,
            type: element.description,
            link: element.idZoom || '',
            counter: null
          },
          tag: {
            label: CardHelpers.getTextprocessed(
              positionSummary,
              CardHelpers.getCardTagLabel(someType),
              'tag',
              someType
            ),
            label2: CardHelpers.getCardTagLabel(someType),
            color: CardHelpers.getCardTagColor(someType),
            background: CardHelpers.getCardTagBackgroundColor(someType)
          },
          icon: CardHelpers.getIconprocessed(positionSummary),
          classTypeText: ''
        };
        break;
      case constants.CARD_TYPES.CURSO_VIRTUAL: // curso : virtual
        entire = parseInt(element.hours, 10);
        dec = Number(
          (element.hours - entire).toFixed(
            Math.abs(
              element.hours.toString().length - entire.toString().length - 1
            )
          )
        );

        hoursText = `${entire} Hrs. ${dec > 0 ? `${dec * 60} minutos` : ''}`;

        objCard = {
          textColor: '#fff',
          summary: {
            title: `Curso: ${courseName}`
          },
          detail: {
            title: courseName,
            date: element.date,
            hour: 'Disponible 24/7',
            teacher: professor,
            counter: hoursText,
            type: null
          },
          tag: {
            label: CardHelpers.getCardTagLabel(someType),
            label2: CardHelpers.getCardTagLabel(someType),
            color: CardHelpers.getCardTagColor(someType),
            background: CardHelpers.getCardTagBackgroundColor(someType)
          },
          classTypeText: '',
          icon: true
        };
        break;
      default:
        objCard = {};
    }

    return objCard;
  };
}
